/**
 * AI.GEN lines=1-80
 * 通用工具函数
 */

// ========== 比较工具 ==========

/**
 * 深比较两个值是否相等（使用 JSON.stringify）
 * @param a 第一个值
 * @param b 第二个值
 * @returns 是否相等
 */
export const isEqual = (a: unknown, b: unknown): boolean => {
  return JSON.stringify(a) === JSON.stringify(b);
};

// ========== 安全工具 ==========

/**
 * 安全解码 URI 字符串
 * @param value 要解码的字符串
 * @param component 是否使用 decodeURIComponent，默认为 true
 * @returns 解码后的字符串，如果解码失败则返回原始值
 */
export function safeDecode(value: string, component = true): string {
  try {
    return component ? decodeURIComponent(value) : decodeURI(value);
  } catch {
    // 遇到非法编码，直接返回原始值
    return value;
  }
}

/**
 * AI.GEN lines=1-12
 * 生成安全的唯一 ID（兼容旧浏览器与非安全上下文）
 * 优先使用 crypto.randomUUID，不可用时回退为时间戳+随机串
 * @returns 唯一 ID 字符串
 */
export function generateSafeId(): string {
  if (
    typeof crypto !== 'undefined' &&
    typeof crypto.randomUUID === 'function'
  ) {
    return crypto.randomUUID();
  }
  return `${Date.now()}-${Math.random().toString(36).slice(2)}`;
}

// ========== 验证工具 ==========

/**
 * 判断值是否为空
 * @param value 值
 * @returns 是否为空
 */
export const isNotEmpty = (value: string | undefined | null): boolean => {
  return value !== undefined && value !== null && value !== '';
};

// ========== 缓存工具 ==========

/**
 * 生成缓存 key
 * @param pathname 路径名
 * @param search 查询字符串，默认为空字符串
 * @returns 缓存 key
 */
export const generateCacheKey = (
  pathname: string,
  search: string = '',
): string => {
  return `${pathname}${search}`;
};

// ========== 选项生成工具 ==========

/**
 * 根据数字范围生成选项数组
 * @param start 起始数字
 * @param end 结束数字
 * @param unit 单位后缀
 * @returns 选项数组
 */
export const generateOptionsByNumber = (
  start: number,
  end: number,
  unit?: string,
) => {
  const options = [];

  for (let i = start; i <= end; i++) {
    options.push({
      label: `${i}${unit || ''}`,
      value: i,
    });
  }

  return options;
};
